module.exports = __webpack_public_path__ + "assets/1f7ab3fb019380da18c824241de6ff1d.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ro/video.ogv
// module id = 358
// module chunks = 1